import { useCallback } from 'react'
import { IUseSmartWayCarrierSubmitter } from 'transfix-form/forms/SmartWayCarrier/types'
import { useGlobalToast } from 'transfix-ui/components/Toast/GlobalToast'
import { TSmartWayCarrierSchema } from '../../../../../../../transfix-form/forms/SmartWayCarrier/components/SmartWayCarrierModal/schema/SmartWayCarrierSchema'
import { TOAST_ERROR_MESSAGE } from '../../../constants'
import { useUpdateSmartWayCarrierMutation } from '../graphql/UpdateSmartWayCarrierMutation'

const TOAST_SUCCESS_MESSAGE = 'SmartWay Carrier preferences updated successfully'

export const useSmartWayCarrierSubmitter = (
  motorCarrierId: string
): IUseSmartWayCarrierSubmitter<TSmartWayCarrierSchema> => {
  const { openToast } = useGlobalToast()
  const [updateSmartWayCarrier, { loading }] = useUpdateSmartWayCarrierMutation()

  const showErrorToast = useCallback(() => {
    openToast({ toastMessage: TOAST_ERROR_MESSAGE, toastType: 'alert' })
  }, [openToast])

  const submitHandler = useCallback(
    async (formValues: TSmartWayCarrierSchema) => {
      try {
        const { errors } = await updateSmartWayCarrier({
          variables: {
            input: {
              motorCarrierId,
              ...formValues,
            },
          },
        })
        if (!errors) {
          openToast({ toastMessage: TOAST_SUCCESS_MESSAGE })
          return true
        }
        showErrorToast()
        return false
      } catch {
        showErrorToast()
        return false
      }
    },
    [motorCarrierId, openToast, showErrorToast, updateSmartWayCarrier]
  )

  return {
    loading,
    submitHandler,
  }
}
